import * as React from 'react';

const OrderDetailEmailSendStatusPopup = (props) => {
    const { data, SetStatus } = props

    const onHide = () => {
        SetStatus(false)
    };

    return (
        <>
            <div className="avnet-modal model-710">
                <div className="avnet-modal-inner">
                    <button type="button" className="close py-3" data-dismiss="modal"
                        onClick={() => { onHide() }}>×</button>

                    <div className="modal-header border-0">
                        <h3 className="modal-title m-auto" id="exampleModalLabel">{data.isSubmitted ? <b>Email Sent</b> : <b>Email Failed</b>}</h3>
                    </div>
                    <div className="bs5 modal-body text-center">
                        {data.isSubmitted ?
                            <>
                                Your Email has been sent
                            </>
                            :
                            <>
                                Your Email has not been sent, please try again.
                            </>}

                    </div>
                    <div className="modal-footer d-flex justify-content-center">
                        <button className="bs5 btn btn-primary"
                            onClick={() => { onHide() }}
                        >CLOSE</button>
                    </div>
                </div>
            </div>
        </>
    )
}

export default OrderDetailEmailSendStatusPopup;